import { render, staticRenderFns } from "./showDispatchDetails.vue?vue&type=template&id=5995dc94&scoped=true&"
import script from "./showDispatchDetails.vue?vue&type=script&lang=js&"
export * from "./showDispatchDetails.vue?vue&type=script&lang=js&"
import style0 from "./showDispatchDetails.vue?vue&type=style&index=0&id=5995dc94&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5995dc94",
  null
  
)

export default component.exports